export default [{
    'id': 'Parking-1',
    'name': 'B01-B02 Parking',
    'lng': 118.04400955231628,
    'lat': 24.614905053537704,
    'height': 41.81788404694946,
    'price': '3 元/小时',
    'total': 156,
    'used': 93,
    'remain': 63,
    'progress': 0.5961538461538461
}, {
    'id': 'Parking-2',
    'name': 'B03-B04 Parking',
    'lng': 118.0418229877947,
    'lat': 24.613646570531827,
    'height': 41.932398074217005,
    'price': '2 元/小时',
    'total': 155,
    'used': 79,
    'remain': 76,
    'progress': 0.5096774193548387
}, {
    'id': 'Parking-3',
    'name': 'B08-B10 Parking',
    'lng': 118.04069684170238,
    'lat': 24.618096203807536,
    'height': 21.192365724892767,
    'price': '2 元/小时',
    'total': 161,
    'used': 105,
    'remain': 56,
    'progress': 0.6521739130434783
}, {
    'id': 'Parking-4',
    'name': 'B11-B15 Parking',
    'lng': 118.03948513574136,
    'lat': 24.616909971869195,
    'height': 30.10599052019309,
    'price': '2 元/小时',
    'total': 167,
    'used': 80,
    'remain': 87,
    'progress': 0.47904191616766467
}, {
    'id': 'Parking-5',
    'name': 'B20-B21 Parking',
    'lng': 118.03706717966568,
    'lat': 24.618357056432437,
    'height': 29.418768785845447,
    'price': '3 元/小时',
    'total': 181,
    'used': 159,
    'remain': 22,
    'progress': 0.8784530386740331
}, {
    'id': 'Parking-6',
    'name': 'B16-B19 Parking',
    'lng': 118.04025197467502,
    'lat': 24.619439175253962,
    'height': 19.191596274067788,
    'price': '2 元/小时',
    'total': 183,
    'used': 101,
    'remain': 82,
    'progress': 0.5519125683060109
}];